import { gql } from '@apollo/client';

export const GET_PRODUCT_CATEGORIES = gql`
  query ProductCategory_find {
    ProductCategory_find {
      id
      name
      description
    }
  }
`;
